<template>
  <b-row>
    <b-col>
      <b-row v-for="mandate in mandates" :key="mandate.id">
        <b-col cols="4">
          {{ getPersonNameAndGender({ personId: mandate.building_owner_id }) }}
          <div>
            <b-badge> {{ getTotalMandateTantiemesChargeGenerale(mandate.id) }} </b-badge>
            <b-badge
              v-if="getReducedMandateTantiemesChargeGenerale(mandate.id)"
              class="ml-1"
              variant="warning"
            >
              {{ getReducedMandateTantiemesChargeGenerale(mandate.id) }}</b-badge
            >
          </div>
        </b-col>
        <b-col cols="8" class="mb-4">
          <label>Sélectionnez un autre représentant</label>
          <v-multiselect
            :ref="'multiselect-move-mandates-' + mandate.id"
            v-model="selectedOwnersOrContacts[mandate.id]"
            :show-labels="false"
            :options="processedOptions(mandate)"
            group-values="items"
            group-label="group"
            :group-select="false"
            :close-on-select="true"
            track-by="identifier"
            label="search"
            placeholder="Tapez pour rechercher"
            open-direction="bottom"
            @select="onSelect($event, mandate.id)"
            @open="onOpen(mandate.id)"
          >
            <template slot="option" slot-scope="props">
              <div v-if="props.option.$groupLabel">
                <strong class="text-primary">{{ props.option.$groupLabel }}</strong>
              </div>
              <div v-else class="d-flex">
                <div v-if="props.option.isParticipant" class="multiselect-participant-indicator" />
                <div class="w-75">
                  <div class="select-option-main d-flex align-items-center">
                    <span class="mr-2">
                      {{ props.option.name }}
                    </span>

                    <div
                      v-if="votingLimitRules.votingLimitIsActive"
                      class="d-flex align-items-center"
                    >
                      <div v-if="props.option.type == 'owner' || props.option.isParticipant">
                        <appBOTantiemes :building-owner-data="props.option" />
                      </div>
                      <div v-if="props.option.isParticipant" class="ml-2">
                        <font-awesome-icon icon="user-tag" />
                        <strong>
                          x
                          {{
                            props.option.type == "owner"
                              ? props.option.totalMandateVotes - 1
                              : props.option.totalMandateVotes
                          }}
                        </strong>
                      </div>
                    </div>
                  </div>
                  <div class="select-option-description">
                    {{
                      props.option.building_lots
                        ? props.option.building_lots.map(x => x.name).join(", ")
                        : ""
                    }}
                  </div>
                </div>
              </div>
            </template>
            <template slot="beforeList" class="p-2">
              <div class="p-3" style="cursor: pointer;" @click="openModalCreateContact(mandate.id)">
                <div><font-awesome-icon icon="plus-circle" /> Ajouter une nouvelle contact.</div>
              </div>
            </template>
            <span slot="noResult" class="mx-2">
              Oops! Aucun élément trouvé. Pensez à modifier la requête de recherche.
            </span>
          </v-multiselect>
          <b-badge
            v-if="
              selectedOwnersOrContacts[mandate.id] &&
              selectedOwnersOrContacts[mandate.id].presenceType
            "
            class="m-2"
            :variant="
              selectedOwnersOrContacts[mandate.id].presenceType == 'video' ? 'info' : 'light'
            "
            :class="{ 'cursor-pointer': !selectedOwnersOrContacts[mandate.id].isParticipant }"
            @click="
              changePresenceTypeForFutureParticipant(
                selectedOwnersOrContacts[mandate.id],
                mandate.id
              )
            "
          >
            {{
              selectedOwnersOrContacts[mandate.id].presenceType == "video" ? "Vidéo" : "Physique"
            }}
          </b-badge>
        </b-col>

        <!-- Modal Create Contact -->
        <b-modal :id="`modal-create-contact-${mandate.id}`" size="lg" hide-footer centered>
          <modalCreateContact
            :building-id="meeting.building_id"
            @closeModal="closeModalCreateContact(mandate.id)"
            @setContact="setContact($event, mandate.id)"
          />
        </b-modal>
      </b-row>

      <b-row>
        <b-col class="d-flex justify-content-end my-2">
          <b-button class="button btn-blue" @click="action">
            <font-awesome-icon icon="check" />
            <span>{{ $t("general.enregistrer") }}</span>
          </b-button>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import meetingPresenceSelectOptionsMixins from "@/mixins/meeting-presence-select-options";
import mandatePresenceMixin from "@/mixins/mandate-presence";
import meetingDetailsMixin from "@/mixins/meeting-details";

import modalCreateContact from "@/components/modals/create-contact/CreateContact";
import appBOTantiemes from "@/components/snippets/BuildingOwnerTantiemes";

export default {
  components: {
    modalCreateContact,
    appBOTantiemes,
  },

  mixins: [meetingPresenceSelectOptionsMixins, mandatePresenceMixin, meetingDetailsMixin],

  props: {
    meeting: {
      type: Object,
      default: () => {
        return {};
      },
    },
    mandates: {
      type: Array,
      default: () => {
        return [];
      },
    },
    options: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      selectedOwnersOrContacts: {},
      justSelected: false,
    };
  },
  created() {
    this.mandates.forEach(mandate => {
      this.$set(this.selectedOwnersOrContacts, mandate.id, null);
    });
  },
  methods: {
    processedOptions(mandate) {
      if (this.votingLimitRules.votingLimitIsActive) {
        return this.getBOsCsShowedUpNotAbsentAndNotShowedUpRestrictedOpts(
          this.options,
          mandate,
          this.selectedOwnersOrContacts,
          this.mandates
        );
      } else {
        return this.options;
      }
    },
    action() {
      var self = this;
      self
        .$swal(self.alertQuestion())
        .then(res => {
          if (res.value) {
            self.$emit("action", self.selectedOwnersOrContacts);
          }
        })
        .catch(err => {
          console.log("err", err);
          self.$swal(self.alertError());
        });
    },
    openModalCreateContact(mandateId) {
      this.$bvModal.show(`modal-create-contact-${mandateId}`);
    },
    closeModalCreateContact(mandateId) {
      this.$bvModal.hide(`modal-create-contact-${mandateId}`);
    },
    setContact(contact, mandateId) {
      // !!!: ..
      var newContactDetails = this.getContactDetails(contact);
      this.selectedOwnersOrContacts[mandateId] = newContactDetails;

      this.$bvModal.hide(`modal-create-contact-${mandateId}`);
    },
    async onSelect(selectedOwnerOrContact, mandateId) {
      // set presenceType & hasDummyVideoPresenceStatus on non participants to use them in MOVE_MANDATES function
      if (
        typeof selectedOwnerOrContact.presenceType == "undefined" ||
        typeof selectedOwnerOrContact.hasDummyVideoPresenceStatus == "undefined"
      ) {
        var chosenPresenceType = await this.promptPresenceType(this.meeting);

        this.setChosenPresenceType(selectedOwnerOrContact, chosenPresenceType, mandateId);

        this.justSelected = true;
      }
    },
    async changePresenceTypeForFutureParticipant(selectedOwnerOrContact, mandateId) {
      if (selectedOwnerOrContact.isParticipant) return;

      var chosenPresenceType = await this.promptPresenceType(this.meeting);

      this.setChosenPresenceType(selectedOwnerOrContact, chosenPresenceType, mandateId);
    },
    setChosenPresenceType(selectedOwnerOrContact, chosenPresenceType, selectedMandateId) {
      if (chosenPresenceType) {
        for (const [mandateId, ownerOrContact] of Object.entries(this.selectedOwnersOrContacts)) {
          if (ownerOrContact && ownerOrContact.id == selectedOwnerOrContact.id) {
            this.$set(
              this.selectedOwnersOrContacts[mandateId],
              "presenceType",
              chosenPresenceType == "video" ? "video" : "physical"
            );
            this.$set(
              this.selectedOwnersOrContacts[mandateId],
              "hasDummyVideoPresenceStatus",
              chosenPresenceType == "video" ? 1 : 0
            );
          }
        }
      } else {
        this.$set(this.selectedOwnersOrContacts, selectedMandateId, null);
      }
    },
    // HACK: because of a strange multiselect behaviour (when onSelect and using await, after the function is finished, it opens again)
    onOpen(mandateId) {
      if (this.justSelected) {
        this.$refs["multiselect-move-mandates-" + mandateId][0].isOpen = false;
        this.justSelected = false;
      }
    },
  },
};
</script>
